
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/buildpc",
      function () {
        return require("private-next-pages/phongvu/desktop/buildpc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phongvu/desktop/buildpc"])
      });
    }
  